<app-progress-spinner
  [color]="color"
  [mode]="mode"
  [value]="value"
  [style.display]="getDisplayProgressSpinner() ? 'flex' : 'none'"
  class="sq-global-backdrop center-aligned">
</app-progress-spinner>
